import React from "react";
import "./Stylesheets/App.css";
import "./Stylesheets/neo.css";
import "./Button/NeoButton.css";
import Footer from "./Components/Footer";
import MenuButton from "./MenuButton";
import AuthManager from "./Auth/AuthManager";
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL, INSURANCE_URL } from "./Constants";
import LoadingSpinner from "./LoadingSpinner";
import NavigationBar from "./NavigationBar/NavigationBar";
import NeoButton from "./Button/NeoButton";
import MultiStoreBanner from "./Components/MultiStoreBanner";
import NeoDropdown from "./Dropdown/NeoDropdown";
import EmptyStateView from "./EmptyStateView";
import moment from "moment";

class Main extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isLoadingData: false,
            isLoadingInvites: false,
            invites: [],
            data: [],
            drafts: [],
            data_backup: [],
            drafts_backup: [],
            status: "offers",
            offers: [],
            offers_backup: [],
            search: "",
            showCreateApplicationModal: false,

            showOfferConvertRateModal: false,
            offerToConvert: null,
            selectedOfferConvertRate: null,
        };

        this.showOffersTable = this.showOffersTable.bind(this);
        this.showVendorDirectOffers = this.showVendorDirectOffers.bind(this);
        this.showVendorDirectHandovers = this.showVendorDirectHandovers.bind(this);
        this.showCustomerDirectOffers = this.showCustomerDirectOffers.bind(this);
        this.showShops = this.showShops.bind(this);
        this.showContact = this.showContact.bind(this);
        this.showProfile = this.showProfile.bind(this);
        this.showMyCompany = this.showMyCompany.bind(this);
        this.showCalc = this.showCalc.bind(this);
        this.showQRScan = this.showQRScan.bind(this);
        this.logout = this.logout.bind(this);
        this.showIDCheck = this.showIDCheck.bind(this);
        this.loadInvites = this.loadInvites.bind(this);
        this.acceptInvite = this.acceptInvite.bind(this);
        this.declineInvite = this.declineInvite.bind(this);

        this.handleChangeFilter = this.handleChangeFilter.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.deleteOffer = this.deleteOffer.bind(this);
        this.openOfferForUpload = this.openOfferForUpload.bind(this);
        this.renderOfferStatus = this.renderOfferStatus.bind(this);
        this.showEntwuerfe = this.showEntwuerfe.bind(this);

        this.openCreateApplicationModal = this.openCreateApplicationModal.bind(this);
        this.closeCreateApplicationModal = this.closeCreateApplicationModal.bind(this);
        this.confirmCreateApplication = this.confirmCreateApplication.bind(this);
        this.renderCreateApplicationModal = this.renderCreateApplicationModal.bind(this);

        this.convertOfferToDraft = this.convertOfferToDraft.bind(this);
        this.closeOfferConvertRateModal = this.closeOfferConvertRateModal.bind(this);
        this.confirmOfferConvertRate = this.confirmOfferConvertRate.bind(this);
        this.renderOfferConvertRateModal = this.renderOfferConvertRateModal.bind(this);
        this.performOfferConvertToDraft = this.performOfferConvertToDraft.bind(this);
        this.getOfferSelectedRates = this.getOfferSelectedRates.bind(this);
        this.renderSelectedRatesText = this.renderSelectedRatesText.bind(this);
    }

    isVendorPage() {
        return this.props.history.location.pathname.includes("/vendor");
    }

    componentDidMount() {
        this.loadDashboard();
        this.setState({ isLoadingInvites: false });
    }

    handleChangeFilter = (status) => {
        this.setState({ isLoadingData: true, status: status.value }, () => {
            this.applySearchFilter(this.state.search);
            setTimeout(() => {
                this.setState({ isLoadingData: false });
            }, 300);
        });
    };

    handleSearchChange(event) {
        const search = event.target.value;
        this.setState({ search });
        this.applySearchFilter(search);
    }

    applySearchFilter(searchValue) {
        const query = (searchValue || "").trim().toLowerCase();

        const matches = (item) => {
            if (query.length === 0) {
                return true;
            }

            const selectedRatesText = this.renderSelectedRatesText(item);

            const haystack = [
                item.id,
                item.object_name,
                item.object_price,
                item.leasing_rate,
                item.leasing_duration,
                item.profile?.company_name,
                item.profile?.contact_name,
                item.profile?.firstname,
                item.profile?.lastname,
                item.note,
                selectedRatesText,
            ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase();

            return haystack.includes(query);
        };

        this.setState({
            offers: this.state.offers_backup.filter(matches),
            drafts: this.state.drafts_backup.filter(matches),
            data: this.state.data_backup.filter(matches),
        });
    }

    loadDashboard() {
        axios.defaults.headers.common.Authorization = `Bearer ${Cookies.get("AccessToken")}`;

        let branchID = Cookies.get("CurrentStoreID") ?? "";

        axios
            .get(BASE_URL + "/vendor/dashboard?branch=" + branchID)
            .then((result) => {
                const dashboard = result.data;

                const offers = dashboard.offers_only ?? [];
                const drafts = dashboard.offers_draft ?? [];
                const data = dashboard.offers ?? [];

                this.setState({
                    offers_backup: offers,
                    drafts_backup: drafts,
                    data_backup: data,
                    offers,
                    drafts,
                    data,
                    isLoading: false,
                });
            })
            .catch((error) => {
                console.log(error);
                this.setState({ isLoading: false });
            });
    }

    loadInvites() {
        axios
            .get(BASE_URL + "/user/company/invites")
            .then((result) => {
                const invites = result.data.invites ?? [];
                this.setState({ invites, isLoadingInvites: false });
            })
            .catch((error) => {
                this.setState({ isLoadingInvites: false });
                console.log(error.response);
            });
    }

    deleteOffer(item, type = "draft") {
        const label = type === "offer" ? "Angebot" : type === "draft" ? "Entwurf" : "Antrag";
        const shouldDelete = window.confirm(`${label} #${item.id} wirklich löschen?`);

        if (!shouldDelete) {
            return;
        }

        this.setState({ isLoadingData: true });

        axios
            .post(BASE_URL + "/vendor/offer-delete", {
                offer_id: item.id,
            })
            .then(() => {
                this.setState(
                    (prevState) => ({
                        offers_backup: prevState.offers_backup.filter((offer) => offer.id !== item.id),
                        drafts_backup: prevState.drafts_backup.filter((draft) => draft.id !== item.id),
                        data_backup: prevState.data_backup.filter((offer) => offer.id !== item.id),
                    }),
                    () => {
                        this.applySearchFilter(this.state.search);
                        this.setState({ isLoadingData: false });
                    }
                );
            })
            .catch(() => {
                this.setState({ isLoadingData: false });
                window.alert("Das Löschen konnte aktuell nicht durchgeführt werden.");
            });
    }

    openOfferForUpload(item) {
        this.props.history.push("/vendor/offers/" + item.id + "/upload");
    }

    renderOfferStatus(item, type = "draft") {
        if (type === "offer") {
            if (item.converted_at || item.application_id || item.converted_to_offer_id) {
                return (
                    <span
                        style={{
                            display: "inline-block",
                            background: "#edf6ff",
                            color: "#2f6fa9",
                            borderRadius: 999,
                            padding: "4px 10px",
                            fontSize: 12,
                            fontWeight: 600,
                        }}
                    >
                        In Antrag gewandelt
                    </span>
                );
            }

            return (
                <span
                    style={{
                        display: "inline-block",
                        background: "#eef8ef",
                        color: "#2f7d32",
                        borderRadius: 999,
                        padding: "4px 10px",
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                >
                    Angebot
                </span>
            );
        }

        if (type === "draft") {
            return (
                <span
                    style={{
                        display: "inline-block",
                        background: "#fff7ed",
                        color: "#9a5b13",
                        borderRadius: 999,
                        padding: "4px 10px",
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                >
                    Entwurf
                </span>
            );
        }

        return (
            <span
                style={{
                    display: "inline-block",
                    background: "#f3f4f6",
                    color: "#4b5563",
                    borderRadius: 999,
                    padding: "4px 10px",
                    fontSize: 12,
                    fontWeight: 600,
                }}
            >
                Antrag
            </span>
        );
    }

    formatMoney(value, divideByHundred = false) {
        if (value === null || typeof value === "undefined" || value === "") {
            return "-";
        }

        let normalized = value;

        if (typeof normalized === "string") {
            normalized = normalized.replace(/\./g, "").replace(",", ".");
        }

        const amount = divideByHundred ? Number(normalized) / 100 : Number(normalized);

        if (Number.isNaN(amount)) {
            return value;
        }

        return amount.toLocaleString("de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    getOfferSelectedRates(item) {
        if (Array.isArray(item.selected_rates) && item.selected_rates.length > 0) {
            return item.selected_rates;
        }

        if (item.leasing_rate != null && item.leasing_duration != null) {
            return [
                {
                    name: new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                    }).format(Number(item.leasing_rate)),
                    value: item.leasing_rate,
                    sub: item.leasing_duration + " Monate",
                    duration: item.leasing_duration,
                    insurance_fee: item.insurance_fee ?? 0,
                    insurance_available: Boolean(item.insurance_fee),
                },
            ];
        }

        return [];
    }

    renderSelectedRatesText(item) {
        const selectedRates = this.getOfferSelectedRates(item);

        if (!selectedRates.length) {
            return "-";
        }

        return selectedRates
            .map((rateOption) => {
                if (rateOption?.name) {
                    return rateOption.name;
                }

                if (typeof rateOption?.value !== "undefined" && rateOption?.value !== null) {
                    return this.formatMoney(rateOption.value);
                }

                return null;
            })
            .filter(Boolean)
            .join(", ");
    }

    convertOfferToDraft(item) {
        const selectedRates = this.getOfferSelectedRates(item);

        if (selectedRates.length === 0) {
            window.alert("Bitte wählen Sie zuerst mindestens eine Rate im Angebot aus.");
            return;
        }

        if (selectedRates.length === 1) {
            this.performOfferConvertToDraft(item, selectedRates[0]);
            return;
        }

        this.setState({
            showOfferConvertRateModal: true,
            offerToConvert: item,
            selectedOfferConvertRate: selectedRates[0],
        });
    }

    performOfferConvertToDraft(item, chosenRate) {
        const selectedRates = chosenRate ? [chosenRate] : this.getOfferSelectedRates(item);

        this.setState({ isLoadingData: true });

        axios
            .post(BASE_URL + "/vendor/offers/draft/update", {
                bucket_type: "draft",
                id: item.id,
                leadingData: item.object_type ?? item.leadingObject ?? "",
                objectName: item.object_name ?? "",
                objectPrice: item.object_price ?? "",
                leadingObject: item.object_type ?? "",
                leasingCondition: item.object_state ?? "new",
                leasingCalculationType: item.leasingCalculationType ?? "rate",
                special_rent_payment: item.special_rent_payment ?? "",
                provision: item.provision ?? 0,
                rate: chosenRate?.value ?? item.leasing_rate ?? 0,
                restwert: item.restwert ?? "",
                bj: item.bj ?? "",
                user: item.profile ?? {},
                leasing_duration: chosenRate?.duration ?? item.leasing_duration ?? 36,
                selected_insurance: item.selected_insurance ?? item.insurance ?? "",
                selected_rates: selectedRates,
                note: item.note ?? "",
                profile: item.profile ?? {},
                isLoading: false,
                object_art: item.object_art ?? item.art ?? "",
            })
            .then(() => {
                this.setState(
                    {
                        isLoadingData: false,
                        showOfferConvertRateModal: false,
                        offerToConvert: null,
                        selectedOfferConvertRate: null,
                    },
                    () => {
                        this.props.history.push("/vendor/offers/" + item.id + "/update?bucket=draft");
                    }
                );
            })
            .catch((error) => {
                this.setState({
                    isLoadingData: false,
                    showOfferConvertRateModal: false,
                });
                window.alert("Das Angebot konnte nicht in einen Antrag überführt werden.");
                console.log(error);
            });
    }

    closeOfferConvertRateModal() {
        this.setState({
            showOfferConvertRateModal: false,
            offerToConvert: null,
            selectedOfferConvertRate: null,
        });
    }

    confirmOfferConvertRate() {
        if (!this.state.offerToConvert || !this.state.selectedOfferConvertRate) {
            return;
        }

        this.performOfferConvertToDraft(
            this.state.offerToConvert,
            this.state.selectedOfferConvertRate
        );
    }

    renderOfferConvertRateModal() {
        if (!this.state.showOfferConvertRateModal || !this.state.offerToConvert) {
            return null;
        }

        const selectedRates = this.getOfferSelectedRates(this.state.offerToConvert);

        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.45)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 20,
                }}
            >
                <div
                    className="neo-card"
                    style={{
                        width: "100%",
                        maxWidth: 700,
                        maxHeight: "85vh",
                        overflowY: "auto",
                        padding: 20,
                        borderRadius: 14,
                        background: "#fff",
                    }}
                >
                    <p className="neo-smallTitle" style={{ marginTop: 0, marginBottom: 12, textAlign: "left" }}>
                        Rate für Antrag auswählen
                    </p>

                    <p className="neo-callout" style={{ marginTop: 0 }}>
                        Es wurden mehrere Laufzeiten / Leasingraten ausgewählt. Bitte wählen Sie aus, welche Rate in den Antrag übernommen werden soll.
                    </p>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: window.innerWidth < 800 ? "1fr" : "1fr 1fr",
                            gap: 12,
                            marginTop: 10,
                        }}
                    >
                        {selectedRates.map((rateOption) => {
                            const isSelected =
                                this.state.selectedOfferConvertRate &&
                                this.state.selectedOfferConvertRate.duration === rateOption.duration &&
                                this.state.selectedOfferConvertRate.value === rateOption.value;

                            return (
                                <div
                                    key={"main-convert-rate-" + rateOption.duration + "-" + rateOption.value}
                                    className="neo-card-cell"
                                    onClick={() => this.setState({ selectedOfferConvertRate: rateOption })}
                                    style={{
                                        cursor: "pointer",
                                        border: isSelected ? "2px solid #5d84b2" : "1px solid #e6ebf2",
                                        borderRadius: 10,
                                        background: isSelected ? "#f4f8fc" : "#fff",
                                    }}
                                >
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                        <div className="neo-smallTitle" style={{ margin: 0 }}>
                                            {rateOption.name}
                                        </div>
                                        <div className="neo-callout" style={{ marginBottom: 0 }}>
                                            {rateOption.sub}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div style={{ display: "flex", gap: 10, marginTop: 20, flexWrap: "wrap" }}>
                        <NeoButton
                            title="Ausgewählte Rate verwenden"
                            onClick={this.confirmOfferConvertRate}
                        />
                        <NeoButton
                            title="Abbrechen"
                            isSecondary={true}
                            onClick={this.closeOfferConvertRateModal}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderOfferActions(item) {
        return (
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <NeoButton
                    style={{ marginTop: 10, cursor: "pointer", width: "auto", paddingLeft: 12, paddingRight: 12 }}
                    title="Bearbeiten"
                    onClick={() => this.props.history.push("/vendor/offers/" + item.id + "/update?bucket=offer")}
                />
                <NeoButton
                    style={{ marginTop: 10, cursor: "pointer", width: "auto", paddingLeft: 12, paddingRight: 12 }}
                    title="Zum Antrag"
                    onClick={() => this.convertOfferToDraft(item)}
                />
                <NeoButton
                    style={{ marginTop: 10, cursor: "pointer", width: "auto", paddingLeft: 12, paddingRight: 12 }}
                    title="Löschen"
                    isDestructive={true}
                    onClick={() => this.deleteOffer(item, "offer")}
                />
            </div>
        );
    }

    showOffersTable() {
        return this.state.isLoadingData ? (
            this.LoadingView()
        ) : this.state.offers.length > 0 ? (
            <table className="styled-table" style={{ borderRadius: 10, border: "1px solid gainsboro", borderCollapse: "collapse" }}>
                <thead style={{ borderRadius: 10 }}>
                <tr>
                    <th>Nr.</th>
                    <th>Datum</th>
                    <th>Kunde</th>
                    <th>Objekt</th>
                    <th>Wert (€)</th>
                    <th>Versicherung</th>
                    <th>Rate (€)</th>
                    <th>Laufzeit</th>
                    <th>Status</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {this.state.offers.map((item) => (
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>
                            {moment(item.created_at).format("DD.MM.YYYY")}
                            <br />
                            {moment(item.created_at).format("HH:mm")} Uhr
                        </td>
                        <td>{item.profile?.company_name ?? item.profile?.contact_name ?? "-"}</td>
                        <td>{item.object_name ?? "-"}</td>
                        <td>{this.formatMoney(item.object_price)}</td>
                        <td>{item.selected_insurance || item.insurance_fee ? "Ja" : "Nein"}</td>
                        <td>{this.renderSelectedRatesText(item)}</td>
                        <td>
                            {this.getOfferSelectedRates(item)
                                .map((rateOption) => rateOption?.duration)
                                .filter(Boolean)
                                .join(", ") || "-"}
                        </td>
                        <td>{this.renderOfferStatus(item, "offer")}</td>
                        <td>{this.renderOfferActions(item)}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        ) : (
            <div className="neo-card" style={{ paddingTop: 1 }}>
                <EmptyStateView message="Keine Angebote gefunden" />
            </div>
        );
    }

    showEntwuerfe() {
        return this.state.isLoadingData ? (
            this.LoadingView()
        ) : this.state.drafts.length > 0 ? (
            <table className="styled-table" style={{ borderRadius: 10, border: "1px solid gainsboro", borderCollapse: "collapse" }}>
                <thead style={{ borderRadius: 10 }}>
                <tr>
                    <th>Nr.</th>
                    <th>Datum</th>
                    <th>Kunde</th>
                    <th>Objekt</th>
                    <th>Wert (€)</th>
                    <th>Versicherung</th>
                    <th>Rate (€)</th>
                    <th>Laufzeit</th>
                    <th>Status</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {this.state.drafts.map((item) => (
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>
                            {moment(item.created_at).format("DD.MM.YYYY")}
                            <br />
                            {moment(item.created_at).format("HH:mm")} Uhr
                        </td>
                        <td>{item.profile?.company_name ?? item.profile?.contact_name ?? "-"}</td>
                        <td>{item.object_name ?? "-"}</td>
                        <td>{this.formatMoney(item.object_price)}</td>
                        <td>{item.selected_insurance || item.insurance_fee ? "Ja" : "Nein"}</td>
                        <td>{item.leasing_rate ? this.formatMoney(item.leasing_rate) : "-"}</td>
                        <td>{item.leasing_duration ?? "-"}</td>
                        <td>{this.renderOfferStatus(item, "draft")}</td>
                        <td>
                            <NeoButton
                                style={{ marginTop: 10, cursor: "pointer", width: "auto", paddingLeft: 12, paddingRight: 12 }}
                                title="Bearbeiten"
                                onClick={() => this.props.history.push("/vendor/offers/" + item.id + "/update?bucket=draft")}
                            />
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        ) : (
            <div className="neo-card" style={{ paddingTop: 1 }}>
                <EmptyStateView message="Keine Entwürfe gefunden" />
            </div>
        );
    }

    showData() {
        return this.state.isLoadingData ? (
            this.LoadingView()
        ) : this.state.data.length > 0 ? (
            <table className="styled-table" style={{ borderRadius: 10, border: "1px solid gainsboro", borderCollapse: "collapse" }}>
                <thead style={{ borderRadius: 10 }}>
                <tr>
                    <th>Nr.</th>
                    <th>Datum</th>
                    <th>Kunde</th>
                    <th>Objekt</th>
                    <th>Wert (€)</th>
                    <th>Versicherung</th>
                    <th>Rate (€)</th>
                    <th>Laufzeit</th>
                    <th>Status</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {this.state.data.map((item) => (
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>
                            {moment(item.created_at).format("DD.MM.YYYY")}
                            <br />
                            {moment(item.created_at).format("HH:mm")} Uhr
                        </td>
                        <td>{item.profile?.company_name ?? item.profile?.contact_name ?? "-"}</td>
                        <td>{item.object_name ?? "-"}</td>
                        <td>{this.formatMoney(item.object_price)}</td>
                        <td>{item.insurance_fee == null ? "Nein" : "Ja"}</td>
                        <td>{item.leasing_rate == null ? "-" : this.formatMoney(item.leasing_rate)}</td>
                        <td>{item.leasing_duration == null ? "-" : item.leasing_duration}</td>
                        <td>{this.renderOfferStatus(item, "done")}</td>
                        <td>
                            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                <NeoButton
                                    style={{ marginTop: 10, width: "auto", paddingLeft: 12, paddingRight: 12 }}
                                    onClick={() => this.openOfferForUpload(item)}
                                    title="Datei uploaden"
                                />
                                <NeoButton
                                    style={{ marginTop: 10, width: "auto", paddingLeft: 12, paddingRight: 12 }}
                                    title="Löschen"
                                    isDestructive={true}
                                    onClick={() => this.deleteOffer(item, "done")}
                                />
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        ) : (
            <div className="neo-card" style={{ paddingTop: 1 }}>
                <EmptyStateView message="Keine Anträge gefunden" />
            </div>
        );
    }

    currentSectionTitle() {
        if (this.state.status === "offers") {
            return "Angebote";
        }

        if (this.state.status === "draft") {
            return "Entwürfe";
        }

        return "Anträge";
    }

    openCreateApplicationModal() {
        this.setState({ showCreateApplicationModal: true });
    }

    closeCreateApplicationModal() {
        this.setState({ showCreateApplicationModal: false });
    }

    confirmCreateApplication() {
        this.setState({ showCreateApplicationModal: false }, () => {
            this.props.history.push("/vendor/offers/create?bucket=draft");
        });
    }

    renderCreateApplicationModal() {
        if (!this.state.showCreateApplicationModal) {
            return null;
        }

        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.45)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 20,
                }}
            >
                <div
                    className="neo-card"
                    style={{
                        width: "100%",
                        maxWidth: 520,
                        padding: 24,
                        borderRadius: 14,
                        background: "#fff",
                    }}
                >
                    <p
                        className="neo-smallTitle"
                        style={{ marginTop: 0, marginBottom: 12, textAlign: "left" }}
                    >
                        Neuen Antrag erstellen
                    </p>

                    <p className="neo-callout" style={{ marginTop: 0, marginBottom: 20 }}>
                        Möchten Sie jetzt einen neuen Antrag anlegen?
                    </p>

                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                        <NeoButton
                            title="Antrag erstellen"
                            onClick={this.confirmCreateApplication}
                        />
                        <NeoButton
                            title="Abbrechen"
                            isSecondary={true}
                            onClick={this.closeCreateApplicationModal}
                        />
                    </div>
                </div>
            </div>
        );
    }

    MainVendor() {
        return (
            <div>
                <div className="neo-card" style={{ marginBottom: 20, paddingTop: 16, paddingBottom: 16 }}>
                    <p className="neo-text" style={{ marginBottom: 8, fontWeight: 600 }}>
                        Angebote & Anträge
                    </p>
                    <p className="neo-text" style={{ color: "#6b7280", marginTop: 0 }}>
                        Erstellte Angebote bleiben erhalten, können erneut bearbeitet werden und lassen sich später in einen Antrag überführen.
                    </p>
                </div>

                <div style={{ marginBottom: 20 }}>
                    <NeoDropdown
                        title="Bereich"
                        items={[
                            { name: "Angebote", value: "offers" },
                            { name: "Anträge", value: "done" },
                            { name: "Entwürfe", value: "draft" },
                        ]}
                        value={this.currentSectionTitle()}
                        onChangeValue={this.handleChangeFilter}
                        trailingString=""
                    />
                </div>

                <div
                    style={{
                        paddingBottom: window.innerWidth < 1000 ? 10 : 0,
                        display: window.innerWidth < 1000 ? "block" : "flex",
                        flexDirection: window.innerWidth < 1000 ? "column" : "row",
                    }}
                >
                    <div style={{ flex: 1 }}>
                        <p className="neo-bar-title">{this.currentSectionTitle()}</p>
                    </div>
                    <div style={{ flex: 1, textAlign: window.innerWidth < 1000 ? "center" : "right" }}>
                        <NeoButton
                            style={{ width: "auto", paddingLeft: 20, paddingRight: 20, marginRight: 20 }}
                            title={"Neuer Antrag"}
                            onClick={() => this.createOffer("requests")}
                        />

                        <NeoButton
                            style={{ width: "auto", paddingLeft: 20, paddingRight: 20, marginRight: 20 }}
                            title={"Neues Angebot"}
                            onClick={() => this.createOffer("offers")}
                        />
                    </div>
                </div>

                <input type="text" placeholder="Suchen" value={this.state.search} onChange={this.handleSearchChange} />

                <div>
                    {this.state.status === "offers" ? this.showOffersTable() : null}
                    {this.state.status === "draft" ? this.showEntwuerfe() : null}
                    {this.state.status === "done" ? this.showData() : null}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="neo-app">
                <NavigationBar showBackButton={false} />

                <div className="neo-content">
                    {this.state.isLoading || this.state.isLoadingInvites
                        ? this.LoadingView()
                        : this.isVendorPage()
                            ? this.MainVendor()
                            : null}
                </div>

                {this.renderCreateApplicationModal()}
                {this.renderOfferConvertRateModal()}

                <Footer />
            </div>
        );
    }

    LoadingView() {
        return <LoadingSpinner title="Laden..." />;
    }

    logout() {
        let authManager = new AuthManager();
        authManager.logout();
        this.props.history.push("/vendor/welcome");
    }

    createOffer(rype) {
        const bucket = rype === "offers" ? "offer" : "draft";

        if (bucket === "draft") {
            this.openCreateApplicationModal();
            return;
        }

        this.props.history.push("/vendor/offers/create?bucket=" + bucket);
    }

    showOffers() {
        this.props.history.push(this.isVendorPage() ? "/vendor/offers" : "/offers");
    }

    showVendorDirectHandovers() {
        this.props.history.push("/vendor/offers/handover");
    }

    showVendorDirectOffers() {
        this.props.history.push("/vendor/offers/direct");
    }

    showCustomerDirectOffers() {
        this.props.history.push("/offers/direct");
    }

    showShops() {
        this.props.history.push("/shops");
    }

    showCalc() {
        this.props.history.push("/rechner/expertenrechner");
    }

    showContact() {
        this.props.history.push(this.isVendorPage() ? "/vendor/contact" : "/contact");
    }

    showProfile() {
        this.props.history.push(this.isVendorPage() ? "/vendor/profile" : "/profile");
    }

    showMyCompany() {
        this.props.history.push("/profile/companygroup");
    }

    showQRScan() {
        this.props.history.push("/vendor/scan");
    }

    showIDCheck() {
        this.props.history.push("/vendor/idCheck");
    }

    showInsurancePage() {
        window.open(INSURANCE_URL, "_blank");
    }

    showInsuranceBedingungenPage(comein) {
        window.open("https://system.gslease.de/versicherung_" + comein + ".pdf", "_blank");
    }

    CompanyInvitationCard(invite) {
        return (
            <div className="neo-card" key={invite.id} style={{ paddingBottom: "10px" }}>
                <p className="neo-text" style={{ maxWidth: "500px" }}>
                    Sie wurden eingeladen, dem Unternehmen {invite.company.name} beizutreten.
                </p>

                <NeoButton title="Beitreten" onClick={() => this.acceptInvite(invite)} />
                <NeoButton title="Löschen" isDestructive={true} onClick={() => this.declineInvite(invite)} />
            </div>
        );
    }

    acceptInvite(invite) {
        this.props.history.push("/invite/" + invite.id);
    }

    declineInvite(invite) {
        axios
            .get(BASE_URL + "/user/company/invite-decline/" + invite.id)
            .then(() => {
                this.loadInvites();
            })
            .catch(() => {});
    }
}

export default Main;